import { Document } from "../../../../models/document";
import { DocumentItem, DocumentItemEdit } from "../../../../models/document-item";
import { DocumentSettings } from "../../../../models/document-settings";
import { DocumentStructure } from "../../../../models/document-structure";
import { DocumentWork, DocumentWorkEdit } from "../../../../models/document-work";
import { UserData } from "../../../../models/user-data";



// ###################################################################################### //
// #                            Memo Functions                                          # //
// ###################################################################################### //


/**
 * Return document structure after adding show_form key for each field.
 * @param documentsStructure 
 * @param settings 
 */
export function getDocumentStructure(documentsStructure?: DocumentStructure[], settings?: DocumentSettings): DocumentStructure[] | undefined {

  if (!documentsStructure || !settings){
    return undefined;
  }
      
  return documentsStructure.map(structure => {

    const show_form = structure.show_form_array.find(showForm => showForm.document_settings_id === settings.id)?.show_form;
    return { ...structure, show_form };

  });
}


/**
 * get this document settings
 * @param document 
 */
export function getDocumentSettings(document?: Document): DocumentSettings | undefined {

  return document?.document_settings? document.document_settings : undefined;
}



/**
 * Checks if Document is closed, to disable changes.
 * Returns boolean.
 * @param document 
 */
export function getIfDocumentClosed(document?: Document): boolean | undefined {
    
  if(!document){
    return undefined;
  }

  return document.status === "סגור" || document.status === "סגור חלקית" || !!document.document_settings?.accounting;
}




// ###################################################################################### //
// #                            forms init functions                                    # //
// ###################################################################################### //


/**
 * init function for document form
 * @param state 
 * @param document 
 */
export function getDocumentFormData(state: UserData, document?: Document) {

  const documentData = {
    id: state?.id ?? document?.id,
    document_number: state?.document_number ?? document?.document_number,
    date_time: state?.date_time ?? document?.date_time,
    document_account: state?.document_account ?? document?.document_account,
    car: state?.car ?? document?.car,
    reference_id: state?.reference_id ?? document?.reference_id,
    reference: state?.reference ?? document?.reference,
    custom_data: state?.custom_data ?? state?.document?.custom_data ?? document?.custom_data,
  };
  

  return documentData;
}


/**
 * init function for works form
 * @param state 
 * @param document 
 */
export function getFormWorksRows(state: UserData, document?: Document): DocumentWorkEdit[] {

    const works = state?.works ?? (state?.document?.works as DocumentWork[])?.map(work => {
        return work.work_id ? { ...work, id: work.work_id } : { ...work, work_id: work.id };
    }) ?? document?.works;

    return works ?? [{
        hours: 1,
        price: 0,
        discount: 0,
        net: 0,
        total: 0,
    }]; 
}



/**
 * init function for items form
 * @param state 
 * @param document 
 */
export function getFormItemsRows(state: UserData, document?: Document): DocumentItemEdit[] {

  const items = state?.items ?? (state?.document?.items as DocumentItem[])?.map(item => {
      return item.item_id ? { ...item, id: item.item_id } : { ...item, item_id: item.id };
    }) ?? document?.items;

  return items ?? [{
    amount: 1,
    price: 0,
    discount: 0,
    net: 0,
    total: 0, 
  }];
}


/**
 * init function for payments form
 * @param state 
 * @param document 
 */
export function getPaymentsRows(state: UserData, document?: Document) {

  const payments = state?.payments ?? state?.document?.payments ?? document?.payments;

  return payments ?? [{
    total: 0,
    // kupa_account_id: 0
    // price: 0,
    // discount: 0,
    // net: 0,
  }];
}